import { push } from "react-router-redux";
import { toastr } from "react-redux-toastr";
import _, { get } from "lodash";
import api from "APP_ROOT/api";
import { SUCCESS } from "LIB/submission/constants";
import { create as addItemToCart } from "APP_ROOT/Nav/RepairOrdersCart/actions";
import { refreshCarts } from "MODULES/session/actions";
import { composables } from "@orange-marmalade/paginate-this";
import * as actionTypes from "./actionTypes";
import repairOrdersPagination, {
  repairOrderLineItems as repairOrderLineItemsPagination,
  reservedForRepairInventory as reservedForRepairInventoryPagination
} from "./pagination";

export const { search, setFilter, pageActions } = repairOrdersPagination;

export const expireLineItems = composables({
  listId: "repairOrders/lineItems"
}).expire;

export const {
  pageActions: lineItemsPageActions
} = repairOrderLineItemsPagination;

export const {
  pageActions: reservedForRepairInventoryActions,
  search: reservedForRepairSearch,
  setFilter: setReservedFilter
} = reservedForRepairInventoryPagination;

export function searchOpenRO(filter, excludeId) {
  return api.repairOrders
    .orderSearch({ received: false, filter })
    .then(({ data: { results } }) => results.filter(i => i.id !== excludeId));
}

export function getLineItems(id) {
  return api.repairOrders
    .show(id)
    .then(({ data: { line_items: lineItems } }) => Promise.resolve(lineItems));
}

function refreshRepairOrderAndLineItems(dispatch, repairOrderID) {
  return api.repairOrders.show(repairOrderID).then(resp => {
    dispatch({ type: actionTypes.SET, repairOrder: resp.data });
    dispatch(expireLineItems());
  });
}

export function addItemToCartAndRefreshList(id) {
  return dispatch => {
    const addItem = () =>
      new Promise((resolve, __) => {
        resolve(dispatch(addItemToCart(id)));
      });

    addItem().then(() => {
      dispatch(reservedForRepairInventoryActions.expire());
    });
  };
}

export function createROLineItem(data) {
  return (dispatch, getState) => {
    const repairOrderId = getState().repairOrderDetail.getIn([
      "repairOrder",
      "id"
    ]);
    return api.repairOrders.lineItems.create(repairOrderId, data).then(() => {
      refreshRepairOrderAndLineItems(dispatch, repairOrderId);
      return SUCCESS;
    });
  };
}

export function cancelROLineItem(id, reason) {
  return (dispatch, getState) => {
    const repairOrderId = getState().repairOrderDetail.getIn([
      "repairOrder",
      "id"
    ]);
    return api.repairOrders.lineItems
      .cancel(id, reason)
      .then(() => refreshRepairOrderAndLineItems(dispatch, repairOrderId));
  };
}

export function removeMainComponent(id) {
  return (dispatch, getState) => {
    const repairOrderId = getState().repairOrderDetail.getIn([
      "repairOrder",
      "id"
    ]);
    return api.repairOrders.lineItems
      .removeMainComponent(id)
      .then(() => refreshRepairOrderAndLineItems(dispatch, repairOrderId));
  };
}

export function requestVendorRma(id, data, close) {
  return (dispatch, getState) => {
    const repairOrderId = getState().repairOrderDetail.getIn([
      "repairOrder",
      "id"
    ]);
    return api.repairOrders.lineItems.vendorRmaRequest(id, data).then(() => {
      close();
      refreshRepairOrderAndLineItems(dispatch, repairOrderId);
    });
  };
}

export function deleteExpectedComponent(id) {
  return (dispatch, getState) => {
    const repairOrderId = getState().repairOrderDetail.getIn([
      "repairOrder",
      "id"
    ]);
    return api.repairOrders.lineItems
      .deleteExpectedComponent(id)
      .then(() => refreshRepairOrderAndLineItems(dispatch, repairOrderId));
  };
}

export function cancelRequestVendorRma(id) {
  return (dispatch, getState) => {
    const repairOrderId = getState().repairOrderDetail.getIn([
      "repairOrder",
      "id"
    ]);
    return api.repairOrders.lineItems
      .cancelVendorRmaRequest(id)
      .then(() => refreshRepairOrderAndLineItems(dispatch, repairOrderId));
  };
}

export function approveROLineItem(id, data, cb = () => {}) {
  return (dispatch, getState) => {
    const repairOrderId = getState().repairOrderDetail.getIn([
      "repairOrder",
      "id"
    ]);
    return api.repairOrders.lineItems
      .approve(id, data)
      .then(() => {
        refreshRepairOrderAndLineItems(dispatch, repairOrderId);
        cb();
        toastr.success("Approved", "Final approval successful");
      })
      .catch(error => {
        const errorMessage =
          (get(error, "errors.estimated_lead_time") &&
            "Estimated Lead Time is Required.") ||
          get(error, "errors.base[0]") ||
          error.message;
        if (errorMessage) toastr.error("Error", errorMessage);
      });
  };
}

export function transferRoLineItem(id, data, cb = () => {}) {
  return dispatch =>
    api.repairOrders.lineItems
      .transfer(id, data)
      .then(({ data: newRepair }) => {
        cb();
        dispatch(push({ pathname: `/repair-orders/${newRepair.id}` }));
        return SUCCESS;
      });
}

export function convertRo(data) {
  return dispatch =>
    api.repairOrders.convert(data).then(({ data: { uuid } }) => {
      dispatch(push({ pathname: `/repair-orders/${uuid}` }));
      dispatch(refreshCarts());
      dispatch(reservedForRepairInventoryActions.expire());
      return SUCCESS;
    });
}

export function updateROLineItem(id, data) {
  return (dispatch, getState) => {
    const repairOrderId = getState().repairOrderDetail.getIn([
      "repairOrder",
      "id"
    ]);
    return api.repairOrders.lineItems
      .update(id, data)
      .then(() => {
        refreshRepairOrderAndLineItems(dispatch, repairOrderId);
        return SUCCESS;
      })
      .catch(error => {
        toastr.error("Error", get(error, "errors.base[0]"));
      });
  };
}

export function cancel(data) {
  return (dispatch, getState) => {
    const repairOrderId = getState().repairOrderDetail.getIn([
      "repairOrder",
      "id"
    ]);
    return api.repairOrders
      .cancel(repairOrderId, data)
      .then(() => {
        refreshRepairOrderAndLineItems(dispatch, repairOrderId);
        return Promise.resolve();
      })
      .catch(err => Promise.reject(err));
  };
}

export function show(id) {
  return dispatch =>
    api.repairOrders.show(id).then(resp => {
      dispatch({
        type: actionTypes.SET,
        repairOrder: resp.data
      });
    });
}

export function find(id) {
  return dispatch =>
    api.repairOrders.find(id).then(resp => {
      dispatch({
        type: actionTypes.SET,
        repairOrder: resp.data
      });
    });
}

export function update(data) {
  return (dispatch, getState) => {
    const repairOrderID = getState().repairOrderDetail.getIn([
      "repairOrder",
      "id"
    ]);

    if (data.contact_id === "Add") {
      data.contact_id = null;
    }

    return api.repairOrders.update(repairOrderID, data).then(() => {
      refreshRepairOrderAndLineItems(dispatch, repairOrderID);

      return SUCCESS;
    });
  };
}

export const bulkUpdateSelectedLineItems = selectedItems => data => (
  dispatch,
  getState
) => {
  const repairOrderID = getState().repairOrderDetail.getIn([
    "repairOrder",
    "id"
  ]);

  data.line_items = data.line_items.filter(l => selectedItems.includes(l.id));

  return api.repairOrders.lineItems
    .bulkUpdate(repairOrderID, data)
    .then(resp => {
      dispatch({
        type: actionTypes.SET,
        repairOrder: resp.data
      });
      refreshRepairOrderAndLineItems(dispatch, repairOrderID);
      return SUCCESS;
    })
    .catch(err => Promise.reject(err));
};

export const bulkUpdateLineItems = data => (dispatch, getState) => {
  const repairOrderID = getState().repairOrderDetail.getIn([
    "repairOrder",
    "id"
  ]);

  return api.repairOrders.lineItems
    .bulkUpdate(repairOrderID, data)
    .then(resp => {
      dispatch({
        type: actionTypes.SET,
        repairOrder: resp.data
      });
      dispatch(lineItemsPageActions.expire());
      return SUCCESS;
    });
};

export function createRequiredComponent(repairItemId, data) {
  return (dispatch, getState) =>
    api.repairOrders.lineItems.requiredComponents
      .create(repairItemId, data)
      .then(() => {
        const repairOrderID = getState().repairOrderDetail.getIn([
          "repairOrder",
          "id"
        ]);
        refreshRepairOrderAndLineItems(dispatch, repairOrderID);
        return SUCCESS;
      });
}

export function shopAssistCostSavings(repairItemId, data) {
  return (dispatch, getState) =>
    api.repairOrders.lineItems
      .shopAssistCostItem(repairItemId, data)
      .then(() => {
        const repairOrderID = getState().repairOrderDetail.getIn([
          "repairOrder",
          "id"
        ]);
        refreshRepairOrderAndLineItems(dispatch, repairOrderID);
        return SUCCESS;
      });
}

export function importLineItems(values) {
  return (dispatch, getState) => {
    const repairOrderID = getState().repairOrderDetail.getIn([
      "repairOrder",
      "id"
    ]);
    const repairOrderUUID = getState().repairOrderDetail.getIn([
      "repairOrder",
      "uuid"
    ]);
    const fileName = values.file.name;

    return api.attachments.upload(values.file.name).then(resp => {
      const { key, url } = resp.data;
      const formattedAttachment = {
        name: fileName,
        key
      };

      return api.attachments
        .toS3(url, values.file)
        .then(() =>
          api.repairOrders.lineItems
            .import(repairOrderID, formattedAttachment)
            .then(() => {
              refreshRepairOrderAndLineItems(dispatch, repairOrderUUID);
              toastr.info("Processing", "Importing.");
              return SUCCESS;
            })
        )
        .catch(e => Promise.reject(e));
    });
  };
}

export function sync() {
  return (dispatch, getState) => {
    const repairOrderID = getState().repairOrderDetail.getIn([
      "repairOrder",
      "id"
    ]);
    return api.repairOrders
      .sync(repairOrderID)
      .then(() => {
        toastr.success("SUCCESS", "Successfully Synced.");

        return SUCCESS;
      })
      .catch(response => {
        toastr.error("ERROR", get(response, "errors", "Sync Failed"));
      });
  };
}



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/actions.js